export default (value: any) => {
  if (value == null || value.toUpperCase() != "YES") { return ""; }
  return "Yes";
};